import { render, staticRenderFns } from "./VoiceAiWrapper.vue?vue&type=template&id=1c0564e4&scoped=true"
import script from "./VoiceAiWrapper.vue?vue&type=script&lang=js"
export * from "./VoiceAiWrapper.vue?vue&type=script&lang=js"
import style0 from "./VoiceAiWrapper.vue?vue&type=style&index=0&id=1c0564e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0564e4",
  null
  
)

export default component.exports